import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppStateModule } from '@core/state/app/app-state.module';
import { WebShellModule } from '@shell/web-shell.module';
import { WindowModule } from 'src/vendor/window/window.module';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { environment } from '@environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { WINDOW_PROVIDERS } from 'src/vendor/window/window.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from '@core/data/http/auth-interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { appRoutes } from './app.routes';
import { AppService } from './app.service';
import { AppLoaderModule } from '@shell/ui/app-loader/app-loader-component.module';
import { ENV_PROVIDERS } from './environment/environment';
import { NavBarComponentModule } from '@shell/ui/nav-bar/nav-bar-component.module';
import { IconComponentModule } from '@shared/elements/icon/icon-component.module';
import { TranslateLoaderFactory } from '@core/translation/translate-session-loader';
import { NumeralModule } from '@vendor/numeral/numeral.module';
import { AppRouterStoreModule } from '@core/router/app-router-store.module';
import { NotFoundComponentModule } from '@components/not-found/not-found-component.module';
import { MobileBlockerComponentModule } from '@shell/ui/mobile-blocker/mobile-blocker-component.module';

// Application wide providers
const APP_PROVIDERS = [
  WINDOW_PROVIDERS,
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    /**
         * Local browser storage setup.
         */
    // LocalStorageModule.forRoot({
    //     prefix: environment.settings.localStoragePrefix,
    //     storageType: 'localStorage',
    // }),
    appRoutes,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(),
    WebShellModule,
    WindowModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader, useFactory: TranslateLoaderFactory, deps: [HttpClient]
      }
    }),
    NumeralModule,
    AppRouterStoreModule,
    // NGRX
    AppStateModule,

    /**
         * Store devtools instrument the store retaining past versions of state
         * and recalculating new states. This enables powerful time-travel
         * debugging.
         *
         * To use the debugger, install the Redux Devtools extension for either
         * Chrome or Firefox
         *
         * See: https://github.com/zalmoxisus/redux-devtools-extension
         */
    !environment.production
    ? StoreDevtoolsModule.instrument({ maxAge: 50, name: 'IHD' })
    : [],


    // Components
    AppLoaderModule,
    NavBarComponentModule,
    IconComponentModule,
    NotFoundComponentModule,
    MobileBlockerComponentModule
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    APP_PROVIDERS,
    ENV_PROVIDERS,
    AppService
  ]
})
export class AppModule {}
